// Cornier独自Wishlist。フレームワーク無しの素のJS。App Proxy /a/wishlist/* を叩く。
(function () {
  'use strict';

  var API_BASE = '/a/wishlist';
  var CACHE_KEY = 'cornier_wl_cache_v1';
  var CACHE_TTL_MS = 5 * 60 * 1000;
  var PENDING_KEY = 'cornier_wl_pending_v1';

  function getCustomerId() {
    var v = document.body.getAttribute('data-customer');
    return v && v !== '' ? v : null;
  }

  // ─── 管理タブ(gyomu /wishlist 設定)で編集した文言・色を反映 ────────────────
  // gyomu「日本語からAI翻訳」の言語コード → Shopify request.locale.iso_code の対応。
  // トースト文言だけが翻訳対象（ボタン文言"Wishlist"は言語を問わず共通のまま）。
  function translationLocaleKey() {
    var iso = (document.body.getAttribute('data-locale') || '').toLowerCase();
    if (iso === 'en') return 'en';
    if (iso === 'ko') return 'ko';
    if (iso === 'fr') return 'fr';
    if (iso === 'zh-cn' || iso === 'zh') return 'zh-CN';
    return null;
  }

  var configPromise = null;
  function loadConfig() {
    if (configPromise) return configPromise;
    configPromise = fetch(API_BASE + '/config')
      .then(function (r) {
        if (!r.ok) throw new Error('config failed');
        return r.json();
      })
      .then(function (cfg) {
        var key = translationLocaleKey();
        var t = key && cfg.translations ? cfg.translations[key] : null;
        if (t && t.toastAdded) cfg.toastAdded = t.toastAdded;
        if (t && t.toastRemoved) cfg.toastRemoved = t.toastRemoved;
        if (t && t.toastError) cfg.toastError = t.toastError;
        return cfg;
      })
      .catch(function () {
        return {};
      });
    return configPromise;
  }

  function applyConfig(cfg) {
    var root = document.documentElement.style;
    var colorMap = {
      colorActiveBg: '--cornier-wl-active-bg',
      colorActiveText: '--cornier-wl-active-text',
      colorInactiveBorder: '--cornier-wl-inactive-border',
      colorInactiveText: '--cornier-wl-inactive-text',
      badgeBg: '--cornier-wl-badge-bg',
      badgeText: '--cornier-wl-badge-text',
    };
    for (var key in colorMap) {
      if (cfg[key]) root.setProperty(colorMap[key], cfg[key]);
    }
    window.CornierWishlistConfig = cfg;
  }

  function itemKey(handle, variantId) {
    return handle + '::' + (variantId || '0');
  }

  // ─── キャッシュ（sessionStorage、ページ内の全ボタン共通） ──────────────────
  var state = { items: null, loading: null };

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.ts !== 'number') return null;
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return parsed.items;
    } catch (e) {
      return null;
    }
  }

  function writeCache(items) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), items: items }));
    } catch (e) {}
  }

  function invalidateCache() {
    try {
      sessionStorage.removeItem(CACHE_KEY);
    } catch (e) {}
  }

  // ─── 一覧取得（ページに1回だけ） ────────────────────────────────────────
  function loadItems() {
    var customerId = getCustomerId();
    if (!customerId) return Promise.resolve([]);
    if (state.items) return Promise.resolve(state.items);
    var cached = readCache();
    if (cached) {
      state.items = cached;
      return Promise.resolve(cached);
    }
    if (state.loading) return state.loading;
    state.loading = fetch(API_BASE + '/list', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('list failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var items = data.items || [];
        state.items = items;
        writeCache(items);
        state.loading = null;
        return items;
      })
      .catch(function () {
        state.items = [];
        state.loading = null;
        return [];
      });
    return state.loading;
  }

  function findItem(items, handle, variantId) {
    // data-wl-variant は文字列、API の variant_id は数値なので String() で揃えて比較する
    var target = variantId ? String(variantId) : null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.product_handle !== handle) continue;
      var itVariant = it.variant_id != null ? String(it.variant_id) : null;
      if (itVariant === target) return it;
      // variant未確定(variant_id=null)のアイテムは、どのサイズを見ていても「登録済み」として扱う
      if (itVariant === null) return it;
    }
    return null;
  }

  // ─── ログイン前に押した操作を覚えておき、ログイン後に自動実行 ──────────────
  function savePendingAdd(handle, variantId) {
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify({ handle: handle, variantId: variantId }));
    } catch (e) {}
  }

  function consumePendingAdd() {
    var customerId = getCustomerId();
    if (!customerId) return;
    var raw;
    try {
      raw = localStorage.getItem(PENDING_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    var pending;
    try {
      pending = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!pending || !pending.handle) return;
    addItem(pending.handle, pending.variantId || null).then(refreshAllButtons);
  }

  // ─── API呼び出し ─────────────────────────────────────────────────────────
  function apiPost(action, body) {
    return fetch(API_BASE + '/' + action, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && data.error) || 'failed');
        return data;
      });
    });
  }

  function addItem(handle, variantId) {
    return apiPost('add', { handle: handle, variant_id: variantId }).then(function () {
      invalidateCache();
      state.items = null;
      return true;
    });
  }

  function removeItem(handle, variantId) {
    return apiPost('remove', { handle: handle, variant_id: variantId }).then(function () {
      invalidateCache();
      state.items = null;
      return true;
    });
  }

  // ─── ボタン描画 ──────────────────────────────────────────────────────────
  function paintButton(btn, isActive) {
    btn.classList.toggle('is-active', !!isActive);
    btn.classList.add('wl-ready');
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    var label = btn.querySelector('[data-wl-label]');
    if (label) {
      var cfg = window.CornierWishlistConfig || {};
      label.textContent = isActive
        ? cfg.buttonTextActive || 'Wishlisted'
        : cfg.buttonTextDefault || 'Wishlist';
    }
  }

  function refreshButton(btn) {
    var handle = btn.getAttribute('data-wl-handle');
    if (!handle) return;
    var variantId = btn.getAttribute('data-wl-variant') || null;
    loadConfig().then(function (cfg) {
      applyConfig(cfg);
      if (!getCustomerId()) {
        paintButton(btn, false);
        return;
      }
      loadItems().then(function (items) {
        paintButton(btn, !!findItem(items, handle, variantId));
      });
    });
  }

  function refreshAllButtons() {
    var btns = document.querySelectorAll('[data-wl-toggle]');
    for (var i = 0; i < btns.length; i++) refreshButton(btns[i]);
    updateHeaderBadge();
  }

  function updateHeaderBadge() {
    if (!getCustomerId()) return;
    loadItems().then(function (items) {
      var badges = document.querySelectorAll('[data-wl-badge]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = items.length > 0 ? String(items.length) : '';
        badges[i].hidden = items.length === 0;
      }
    });
  }

  function showToast(msg) {
    var el = document.querySelector('[data-wl-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-wl-toast', '');
      el.className = 'cornier-wl-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2200);
  }

  function handleToggleClick(e) {
    var btn = e.currentTarget;
    var handle = btn.getAttribute('data-wl-handle');
    if (!handle) return;
    var variantId = btn.getAttribute('data-wl-variant') || null;
    var requireVariant = btn.getAttribute('data-wl-require-variant') === 'true';

    if (!getCustomerId()) {
      savePendingAdd(handle, variantId);
      var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = '/account/login?return_url=' + returnUrl;
      return;
    }

    if (requireVariant && !variantId) {
      showToast('サイズを選択してください');
      return;
    }

    var wasActive = btn.classList.contains('is-active');
    paintButton(btn, !wasActive); // optimistic
    var op = wasActive ? removeItem(handle, variantId) : addItem(handle, variantId);
    op.then(function () {
      updateHeaderBadge();
      var cfg = window.CornierWishlistConfig || {};
      var msg = wasActive ? cfg.toastRemoved : cfg.toastAdded;
      if (msg) showToast(msg);
      document.dispatchEvent(new CustomEvent('cornier-wishlist:toggled', { detail: { btn: btn, active: !wasActive } }));
    }).catch(function () {
      paintButton(btn, wasActive); // revert
      var cfg = window.CornierWishlistConfig || {};
      showToast(cfg.toastError || '通信に失敗しました。もう一度お試しください');
    });
  }

  function bindButton(btn) {
    if (btn._wlBound) return;
    btn._wlBound = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleToggleClick(e);
    });
    refreshButton(btn);
  }

  function scan(root) {
    var btns = (root || document).querySelectorAll('[data-wl-toggle]');
    for (var i = 0; i < btns.length; i++) bindButton(btns[i]);
  }

  // 商品ページ: variant切り替えに追従（Dawnの product-form は variant選択が
  // 変わると hidden input[name="id"] の値を書き換える。それをポーリングでなく
  // change イベントで拾う。inputはvariant-pickerがradio/selectを変更した瞬間に
  // dispatchするnative changeイベントをバブリングで拾えばよい）。
  function watchVariantChange() {
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || (target.tagName !== 'INPUT' && target.tagName !== 'SELECT')) return;
      var form = target.closest('product-form');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      var container = form.closest('.product__info-container') || document;
      var btn = container.querySelector('[data-wl-toggle][data-wl-product-scope]');
      if (!btn) return;
      btn.setAttribute('data-wl-variant', idInput.value || '');
      refreshButton(btn);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan();
    watchVariantChange();
    consumePendingAdd();
    updateHeaderBadge();
  });

  // Quick-add モーダル等、後からDOMに差し込まれるカードにも対応
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) scan(added[j]);
      }
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    mo.observe(document.body, { childList: true, subtree: true });
  });

  function invalidateAndRefresh() {
    invalidateCache();
    state.items = null;
    refreshAllButtons();
  }

  // 一括追加/削除(共有ページの「すべて追加する」ボタン)専用。結果は自明
  // (実行したのがadd/removeそのもの)なので、/a/wishlist/list を再取得して
  // 待つ必要がない。再取得待ちだと二重ハートより数秒遅れてカード側の
  // ハートが変わって見える(owner報告2026-09-16)。
  function setAllButtonsActive(active) {
    invalidateCache();
    state.items = null;
    var btns = document.querySelectorAll('[data-wl-toggle]');
    for (var i = 0; i < btns.length; i++) paintButton(btns[i], active);
    updateHeaderBadge(); // バッジ件数は自明でないため再取得を待ってよい(見た目のズレなし)
  }

  // ready(): 管理画面で設定したハートの色(CSS変数)を適用し終えてからresolveする。
  // 一覧ページはこれを待ってからカードを表示し、色が後から変わるのを防ぐ
  function ready() {
    return loadConfig().then(applyConfig);
  }

  window.CornierWishlist = { refreshAllButtons: invalidateAndRefresh, setAllButtonsActive: setAllButtonsActive, ready: ready };
})();
